<div class="clients-container">
  <div class="page-top-banner">
    <div class="title">Clients</div>
    <div class="action-zone">
      <button mat-icon-button class="accent-button" (click)="createClient()">
        <mat-icon>add</mat-icon>
        <span class="text-button">Créer un client</span>
      </button>
    </div>
  </div>

  <div class="table-container">
    <form class="filters-form" [formGroup]="filtersForm">
      <div class="mat-elevation-z8 general-table">
        <table mat-table class="default-table" [dataSource]="dataSource" matSort>

          <!-- Nom -->
          <ng-container matColumnDef="nom">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Nom</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="nom" (keyup)="applyFilters()" autocomplete="off" />
                  <button mat-icon-button matSuffix matTooltip="Réinitialiser" (click)="resetColumnFilter('nom')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let client">{{ client.nom }}</td>
          </ng-container>

          <!-- SIRET -->
          <ng-container matColumnDef="Siret">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>SIRET</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="Siret" (keyup)="applyFilters()" autocomplete="off" />
                  <button mat-icon-button matSuffix matTooltip="Réinitialiser" (click)="resetColumnFilter('Siret')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let client">{{ client.Siret || '-' }}</td>
          </ng-container>

          <!-- Email -->
          <ng-container matColumnDef="Email">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Email</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="Email" (keyup)="applyFilters()" autocomplete="off" />
                  <button mat-icon-button matSuffix matTooltip="Réinitialiser" (click)="resetColumnFilter('Email')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let client">{{ client.Email }}</td>
          </ng-container>

          <!-- Téléphone -->
          <ng-container matColumnDef="Phone">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Téléphone</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="Phone" (keyup)="applyFilters()" autocomplete="off" />
                  <button mat-icon-button matSuffix matTooltip="Réinitialiser" (click)="resetColumnFilter('Phone')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let client">{{ client.Phone }}</td>
          </ng-container>

          <!-- Ville -->
          <ng-container matColumnDef="City">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Ville</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="City" (keyup)="applyFilters()" autocomplete="off" />
                  <button mat-icon-button matSuffix matTooltip="Réinitialiser" (click)="resetColumnFilter('City')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let client">{{ client.City || '-' }}</td>
          </ng-container>

          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let client">
              <div class="actions-cell">
                <button mat-icon-button (click)="editClient(client)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button (click)="confirmDelete(client)">
                  <mat-icon>delete</mat-icon>
                </button>
                <mat-icon class="status-icon" [ngClass]="client.enabled ? 'status-active' : 'status-inactive'"
                  [matTooltip]="client.enabled ? 'Client actif' : 'Client inactif'">
                  {{ client.enabled ? 'check_circle' : 'cancel' }}
                </mat-icon>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <mat-paginator class="default-paginator" [pageSizeOptions]="[10]"></mat-paginator>
      </div>
    </form>
  </div>
</div>